import React, { useEffect, useState, useRef } from "react"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"

interface PhoneInputFieldProps {
  value: string
  inputClass?: string
  inputStyle: React.CSSProperties
  buttonStyle?: React.CSSProperties
  buttonClass?: string
  camp?: any
  countryCode?: string
  onChange: (phone: string, country: any) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  value,
  inputClass,
  inputStyle,
  buttonStyle,
  buttonClass,
  camp,
  countryCode,
  onChange,
  onBlur,
  onKeyDown,
}) => {
  const [country, setCountry] = useState("us")
  const lastCountryDataRef = useRef({})

  useEffect(() => {
    if (camp?.country) {
      if (camp.country === "EU") {
        setCountry("gr")
      } else {
        setCountry(camp.country.toLowerCase())
      }
    } else {
      setCountry("us")
    }
  }, [camp?.country])

  const handleChange = (phone: string, countryData: any) => {
    if (countryData) {
      lastCountryDataRef.current = countryData
    }
    onChange(phone, countryData)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      (e.key === "Backspace" || e.key === "Delete") &&
      window.getSelection().toString() === (e.target as HTMLInputElement).value
    ) {
      e.preventDefault()
      onChange("", lastCountryDataRef.current)
      return
    }

    if (onKeyDown) {
      onKeyDown(e)
    }
  }

  return (
    <PhoneInput
      inputClass={inputClass}
      buttonStyle={buttonStyle}
      buttonClass={buttonClass}
      inputStyle={inputStyle}
      countryCodeEditable={false}
      country={country}
      value={value}
      preferredCountries={["us", "ca", "de", "au", "nz", "nl", "mx"]}
      inputProps={{
        name: "phone",
        required: true,
      }}
      onChange={handleChange}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      enableSearch={true}
      disableSearchIcon={true}
    />
  )
}

export default PhoneInputField
